export type Priority = 'critical' | 'warn' | 'ok'

export type ItemForDisplay = {
  id:                string
  name:              string
  qtyRemaining:      number
  lowStockThreshold: number
  daysUntilExpiry:   number | null
  expiryIsReal?:     boolean
}

export function getPriority(item: ItemForDisplay): Priority {
  if (item.qtyRemaining <= 0) return 'critical'
  if (item.qtyRemaining <= item.lowStockThreshold) return 'critical'
  if (item.daysUntilExpiry !== null && item.daysUntilExpiry <= 7) return 'warn'
  return 'ok'
}

export function getSubtitle(item: ItemForDisplay, priority: Priority): string {
  if (priority === 'critical') return 'Running low — add to list'
  if (priority === 'warn' && item.daysUntilExpiry !== null) {
    if (item.expiryIsReal) {
      if (item.daysUntilExpiry <= 0) return 'Expires today'
      const day = addDays(new Date(), item.daysUntilExpiry)
      const dayName = day.toLocaleDateString('en-US', { weekday: 'long' })
      return `Expires ${dayName} · ${item.daysUntilExpiry} day${item.daysUntilExpiry === 1 ? '' : 's'}`
    }
    return `Running low · ~${item.daysUntilExpiry}d supply left`
  }
  return 'Well stocked'
}

function addDays(base: Date, days: number): Date {
  const d = new Date(base)
  d.setDate(d.getDate() + days)
  return d
}

function computeDaysUntilExpiry(expiresAt: string | Date | null | undefined): number | null {
  if (!expiresAt) return null
  const exp = new Date(expiresAt)
  const now = new Date()
  return Math.floor((exp.getTime() - now.getTime()) / (1000 * 60 * 60 * 24))
}

export function adaptItemForDisplay(raw: any): ItemForDisplay {
  const isOut = raw.status === 'red' || raw.status === 'used'
  const isLow = raw.status === 'amber'

  let daysUntilExpiry: number | null = null
  let expiryIsReal = false

  if (raw.track_expiration && raw.current_expiration_date) {
    daysUntilExpiry = computeDaysUntilExpiry(raw.current_expiration_date + 'T00:00:00')
    expiryIsReal = true
  } else if (isLow && typeof raw.daysRemaining === 'number') {
    daysUntilExpiry = Math.max(0, raw.daysRemaining)
    expiryIsReal = false
  }

  return {
    id:                raw.id,
    name:              raw.name,
    qtyRemaining:      isOut ? 0 : 10,
    lowStockThreshold: 1,
    daysUntilExpiry,
    expiryIsReal,
  }
}
